module.exports = __webpack_public_path__ + "img/hd-stamp.efbfb341.png";